import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {Location} from '@angular/common';
import { DatesHelpersService } from '../../../services/tools/dates-helpers.service';
import { ErrorModalComponent } from '../../../components/tools/modals/error-modal/error-modal.component';
import { SucursalesService } from '../../../services/sucursales.service';
import { HelpersService } from '../../../services/tools/helpers.service';
import { FondeadoresService } from '../../../services/fondeadores.service';
import { BeneficiariosService } from '../../../services/beneficiarios.service';
import { ProductosFinancierosService } from '../../../services/productos-financieros.service';
import { MatRadioChange } from '@angular/material';
import { EmpresasService } from '../../../services/empresas.service';
import { ConstantsService } from '../../../services/constants.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SocioFondeadorService } from '../../../services/socio-fondeador.service';

declare var $;
type NewType = EventEmitter<string>;

@Component({
  selector: 'app-registro-fondeador',
  templateUrl: './registro-fondeador.component.html',
  styleUrls: ['./registro-fondeador.component.scss']
})
export class RegistroFondeadorComponent implements OnInit {

  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  
  public convenio : any = {};
  public errors:any = {};
  public errors_beneficiario:any = {};
  //public fechaInicio: string = null;
  public fecha_inicio_inversion: string = null;
  public isLoading: boolean = false;
  public processing: boolean = false;
  public sucursales: any[] = [];
  public sucursalSelected: any = {id:null};
  public sucursalPorDefecto: string = "";
  public opcTipoEntidad :string="";
  public opcTipoFondo :string="";
  public opcDepositoFondo :string="";
  public isBanco: boolean = false; //Bandera para saber si en deposito de fondos seleccionó banco
  public isNuevoBeneficiario: boolean = false;
  //Variable del ngModel del form beneficiario
  public beneficiario: any = {};
  //Variable del ngModel del form para fondeador
  public fondeador: any = {};
  public esquema_inversion: any = { monto: 0, tasa: 0, plazo: 0};
  //Beneficiario_1
  public beneficiario_1: any = {id:null};
  public beneficiariosOpc: any[] = [];
  public beneficiarioPorDefecto: string = "";
  //Beneficiario_2
  public beneficiario_2: any = {id:null};
  public isPersonaFisica: boolean = false;
  //Productos financieros
  public producto_financiero: any = {id:null};
  public productosOpc: any[] = [];
  public productoPorDefecto: string = "";
  public fechaFin_inversion: string = "";
  public fechaTemp: any = null;
  public tipo_fondeador: string = "";
  public monto_min: number =0;
  public monto_max: number =0;
  //Capitalización
  public opcCapitalizacion: string = "";
  public opcRetencionImpuestos: string = "";
  public isRetencionImpuestos:boolean = false;
  //Simulacion
  public simulacion:boolean = false;
  public simulacionAhorrador:boolean = false;
  //Tipo de fondeador
  public esAhorrador:boolean = false;
  public esInversionista:boolean = false;
  public tipoInversionista:boolean = true;
  //Empresas
  public empresa: any = {id:null};
  public empresasOpc: any[] = [];
  public empresaPorDefecto: string = "";
  //Tipos de fondeador
  public tiposFondeador: string[] = ['ahorrador', 'inversionista'];
  //Plazas
  public plazas: any = {id:null};
  public plazasOpc: any[] = [];
  public plazaPorDefecto: string = "";
  //Actualizar
  public isUpdate : boolean = false;
  public idFondeador : number = 0;
  //Inversión ahorrador
  public inversion_ahorrador: any = {};
  //Para registrar socios
  public socio_fondeador :  any = {};
  public idSocio: number = 0;
  public bandSocio: boolean = false;
  //Para clave o tarjeta
  public esTarjeta: boolean = false;
  public esCLABE: boolean = false;

  //Promotores
  public promotores: any[] = [];
  public promotorSelected: any = {id:null};
  public promotorPorDefecto: string = "";

  //Para el archivo
  public fileList_INE: FileList;
  public fileList_Comprobante: FileList;
  public fileList_RFC: FileList;

  public archivo_ine: string = "";
  public archivo_dom: any = null;
  public archivo_rfc: any = null;

  public formData : FormData = new FormData();

  @Output() public goToCallback: NewType = new EventEmitter;
  
  constructor(
    public location : Location,
    private datesHelper : DatesHelpersService,
    private sucursalesService: SucursalesService,
    private helperService: HelpersService,
    private fondeadoresService: FondeadoresService,
    private socioFondeadorService: SocioFondeadorService,
    private beneficiariosService: BeneficiariosService,
    private productosService: ProductosFinancierosService,
    private empresasService: EmpresasService,
    private constantsService: ConstantsService,
    private activatedRoute : ActivatedRoute,
    private router : Router
  ) { }

  ngOnInit() {
    // let defaultDates = this.datesHelper.getMonthDate();
    // this.fechaInicio = defaultDates.fechaInicio;
    this.getPromotores();
    this.getSucursales();
    this.getEmpresas();
    this.addPlazas();

    //this.getProductosFinancieros();
    this.fondeador = this.fondeadoresService.getDefaultSchedule();

    this.idFondeador = this.activatedRoute.snapshot.params.idFondeador;
    if(this.idFondeador != undefined){
      this.isUpdate = true;
      console.log("Trae ID: ", this.idFondeador);
      this.obtFondeadorId(this.idFondeador);
    }else{
      console.log("Es registrar");
    }
    
    //Para socios fondeadores
    // this.idSocio = this.activatedRoute.snapshot.params.idSocio;
    // if(this.idSocio != undefined){
    //   console.log("Va a registrar esquema del socio");
    //   this.obtSocioId(this.idSocio);
    //   this.bandSocio = true;
    // }else{
    //   console.log("Es registrar normal");
    // }
    // this.getSucursales();
    // this.getEmpresas();
    // this.addPlazas();
  }

  public recibirFlag(flag:boolean){
    this.simulacion = false;
  }

  public recibirFlagAhorrador(flag:boolean){
    this.simulacionAhorrador = false;
    this.esAhorrador = true;
  }
  private getSucursales(){
    this.sucursalesService.getSelect().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content;
          console.log("La sucursales: ", this.sucursales);
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursalSelected =  this.sucursales[0];
            console.log("Sucursal: ",this.sucursalSelected);
          }
          //this.getGastos();
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Obtener listado de empresas
  private getEmpresas(){
    this.empresasService.getSelect().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.empresasOpc = jsonResult.content;
          console.log("Lista Empresas: ", this.empresasOpc);
          if (this.empresasOpc.length>1){
            this.empresaPorDefecto = "Seleccione";
          } else if(this.empresasOpc.length>0){
            this.empresa =  this.empresasOpc[0];
            console.log("Empresa select: ",this.empresa);
          }
          //this.getGastos();
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Obtener listado de promotores
  //Promotores
  private getPromotores(){
    console.log("GetPromotores")
    this.fondeadoresService.obtenerListadePromotores().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        console.log(jsonResult);
        this.promotores = jsonResult;
        console.log("Los promotores: ", this.promotores);
        if (this.promotores.length>1){
          this.promotorPorDefecto = "Seleccione";
        } else if(this.promotores.length>0){
          this.promotorSelected =  this.promotores[0];
          console.log("promotor: ",this.promotorSelected);
        }
        // if(jsonResult.content){
        //   //this.getGastos();
        // }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Obtener Fondeador por ID para actualizar
  public obtFondeadorId(id:number){
    this.isLoading = true;
    this.fondeadoresService.getFondeadorEspecifico(this.idFondeador).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        console.log("Json: ", jsonResult);
        
        if(jsonResult.content){
          this.fondeador = jsonResult.content;
          console.log("Fondeador ID: ", this.fondeador);
          this.selectSucursal(this.fondeador.idSucursal);
          this.selectPromotor(this.fondeador.idPromotor);
          this.opcTipoEntidad = this.fondeador.tipo_entidad;
          //Tipo de persona
          if(this.fondeador.tipo_entidad === "fisica"){
            this.isPersonaFisica = true;
          }
          //Tipos de fondeadores
          if(this.fondeador.tipo_fondeador === "ahorrador"){
            this.selectEmpresa(this.fondeador.idEmpresa)
            this.esAhorrador = true;
          }

          if(this.fondeador.tipo_fondeador === "inversionista"){
            this.selectPlaza(this.fondeador.plaza)
            this.esInversionista = true;
          }

          //Depósito de fondos
          this.opcDepositoFondo = this.fondeador.deposito_fondos;

          if(this.fondeador.deposito_fondos === "transferencia"){
            this.isBanco = true;
          }else{
            this.isBanco = false;
          }

          //Tipo de CLABE o tarjeta
          this.opcTipoFondo = this.fondeador.tipo_clabe_tarjeta;
          if(this.opcTipoFondo == "tarjeta"){
            this.esTarjeta = true;
          }else if(this.opcTipoFondo == "clabe"){
            this.esCLABE = true;
          }else{
            this.esTarjeta = false;
            this.esCLABE = false;
          }

          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  
  //Obtener Fondeador por ID para actualizar
  public obtSocioId(id:number){
    this.isLoading = true;
    this.socioFondeadorService.getSocioEspecifico(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        console.log("Json: ", jsonResult);
        
        if(jsonResult.content){
          this.fondeador = jsonResult.content;
          console.log("Socio ID: ", this.fondeador);
          this.selectSucursal(this.fondeador.idSucursal);
          this.selectPromotor(this.fondeador.idPromotor);
          this.opcTipoEntidad = this.fondeador.tipo_entidad;
          //Tipo de persona
          if(this.fondeador.tipo_entidad === "fisica"){
            this.isPersonaFisica = true;
          }

          if (this.fondeador.tipo_fondeador === 'ahorrador') {
            this.selectEmpresa(this.fondeador.idEmpresa);
            this.esAhorrador = true;
            this.tipo_fondeador = "Ahorrador";
            this.esInversionista = false;
            this.tipoInversionista = false;
            //this.getProductosFinancierosTipo();
          }else if(this.fondeador.tipo_fondeador === 'inversionista'){
            this.selectPlaza(this.fondeador.plaza);
            this.esAhorrador = false;
            this.tipoInversionista = true;
            this.tipo_fondeador = "Inversionista";
            this.esInversionista = true;
            //this.getProductosFinancierosTipo();
          }

          //Usamos un object temporal
          this.socio_fondeador = Object.assign({} , this.fondeador);
          console.log("Temp socio: ", this.socio_fondeador);
          this.fondeador = this.fondeadoresService.getDefaultSchedule();
          //Asignamos datos
          for (var key in this.socio_fondeador){
            for(var clave in this.fondeador){
              if(key == clave){
                this.fondeador[clave] = this.socio_fondeador[key];
              }
            }
          }
          this.fondeador.monto = this.socio_fondeador.saldo;
          this.fondeador.clave = this.socio_fondeador.clave;
          this.fondeador.idSocio = this.socio_fondeador.id;
          console.log("SF: ", this.fondeador);
          
          this.isLoading = false;
          
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Cambiar select sucursales
  private selectSucursal(sucursal){
    let component = this;
    this.sucursales.forEach(function(tipo) {
      if(tipo.id === sucursal){
        component.sucursalSelected = tipo;
      }
    });
  }

  //Cambiar plazas
  private selectPlaza(plazaSelect){
    let component = this;
    this.plazasOpc.forEach(function(tipo) {
      if(tipo.nombre === plazaSelect){
        component.plazas = tipo;
      }
    });
  }
  //Cambiar empresas
  private selectEmpresa(empresaSelect){
    let component = this;
    for (let index = 0; index < this.empresasOpc.length; index++) {
      const tipo = this.empresasOpc[index];
      if(tipo.id === empresaSelect){
        component.empresa = tipo;
      }
      
    }
  }

  //Cambiar select Promotores
  private selectPromotor(promotor){
    let component = this;
    this.promotores.forEach(function(tipo) {
      if(tipo.id === promotor){
        component.promotorSelected = tipo;
      }
    });
  }

  //Función para guardar fondeador
  public guardarFondeador(){
    this.errors = [];
    
    if (this.promotorSelected.id === null){
      this.fondeador.promotor = '';
    }else{
      this.fondeador.idPromotor = this.promotorSelected.id;
    }

    if(this.sucursalSelected.id === null){
      this.fondeador.idSucursal = "";
    }
    else
    {
      this.fondeador.idSucursal = this.sucursalSelected.id;
    }
    
    if(this.opcTipoEntidad.length < 1){
      this.fondeador.tipo_entidad = null;
    }
    else
    {
      this.fondeador.tipo_entidad = this.opcTipoEntidad;
    }

    //Deposito de fondos
    if(this.opcDepositoFondo.length < 1){
      this.fondeador.deposito_fondos = null;
    }
    else
    {
      this.fondeador.deposito_fondos = this.opcDepositoFondo;
    }
    //Agregar null si no tiene clave de elector
    if(this.fondeador.clave_elector === "" ){
      this.fondeador.clave_elector = null;
    }

    //Validar tipo de fondeador
    //Validaciones para la plaza y las empresas
    if(this.fondeador.tipo_fondeador === ""){
      this.fondeador.plaza = null;
      this.fondeador.idEmpresa = null;
    } 

    if(this.fondeador.tipo_fondeador === "inversionista"){
      //Plaza
      if(this.plazas.id === null){
        this.fondeador.plaza = null;
      }
      else
      {
        this.fondeador.plaza = this.plazas.nombre;
        this.fondeador.idEmpresa = null;
        this.empresa = {};
      }
      
    }else if(this.fondeador.tipo_fondeador === "ahorrador"){
      //Empresas
      if(this.empresa.id === null){
        this.fondeador.idEmpresa = null;
      }
      else
      {
        this.fondeador.idEmpresa = this.empresa.id;
        this.fondeador.plaza = null;
        this.plazas = {};
      }
    }
    //Validar saldo
    if(this.fondeador.saldo == ""){
      this.fondeador.saldo = 0;
    }
    //Verificamos el tipo CLABE o tarjeta
    if(this.opcTipoFondo.length < 1){
      this.fondeador.tipo_clabe_tarjeta = null;
    }
    else
    {
      this.fondeador.tipo_clabe_tarjeta = this.opcTipoFondo;
    }

    //Agregar null si no tiene nombre de banco
    if(this.fondeador.nombre_banco === "" ){
      this.fondeador.nombre_banco = null;
    }
    //Agregar null si no tiene numero de cuenta
    if(this.fondeador.numero_cuenta === "" ){
      this.fondeador.numero_cuenta = null;
    }
    //Agregar null si no tiene cuenta o tarjeta
    if(this.fondeador.num_clabe_tarjeta === "" ){
      this.fondeador.num_clabe_tarjeta = null;
    }
    
    //Validacion general para los datos del banco cuando sea efectivo todos los campos pasan a null
    if(this.fondeador.deposito_fondos === "efectivo" || this.fondeador.deposito_fondos === "cheque"){
      this.fondeador.nombre_banco = null;
      this.fondeador.numero_cuenta = null;
      this.fondeador.tipo_clabe_tarjeta = null;
      this.fondeador.num_clabe_tarjeta = null;
    }
    
    //Funcion para validar campos del fondeador
    this.errors = this.fondeadoresService.validate(this.fondeador);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    console.log("Datos fondeador: ", this.fondeador);
    
    this.registrarNuevoSocio();
    
  }

  public armarFormData(){
    //Guardar json dentro de form Data
    this.formData.append("json_fondeador", JSON.stringify(this.fondeador));
    //Validamos archivos
    if( this.fondeador.archivo_ine != null && this.fondeador.archivo_ine.length > 0){
      let file_ine: File = this.fondeador.archivo_ine[0];
      this.formData.append("archivo_ine", file_ine);
    }else{
      this.formData.append("archivo_ine", null);
    }
    if(this.fondeador.archivo_domicilio != null && this.fondeador.archivo_domicilio.length > 0){
      let file_comp: File = this.fondeador.archivo_domicilio[0];
      this.formData.append("archivo_domicilio", file_comp);
    }else{
      this.formData.append("archivo_domicilio", null);
    }
    if(this.fondeador.archivo_rfc != null && this.fondeador.archivo_rfc.length > 0){
      let file_rfc: File = this.fondeador.archivo_rfc[0];
      this.formData.append("archivo_rfc", file_rfc);
    }else{
      this.formData.append("archivo_rfc", null);
    }
  }
  
  //Validar porcentaje de los beneficiarios
  public validarPorcentaje(num_beneficiario: number){
    if(num_beneficiario == 1){
      if(this.fondeador.porcentaje_b1 < 0){
        alert("El porcentaje no puede ser un valor negativo");
        this.fondeador.porcentaje_b1 = 0;
      }else if(this.fondeador.porcentaje_b1 > 100){
        alert("El porcentaje no puede ser mayor a 100%");
        this.fondeador.porcentaje_b1 = 100;
      }else if(!this.isNuevoBeneficiario){
        if(this.fondeador.porcentaje_b1 < 100){
          alert("El porcentaje no puede ser menor a 100% para un solo beneficiario");
          this.fondeador.porcentaje_b1 = 100;
        }
      }else if(this.isNuevoBeneficiario){
        var nuevo_porcentaje = 100 - this.fondeador.porcentaje_b1;
        this.fondeador.porcentaje_b2 = nuevo_porcentaje;
      }
    }else if(num_beneficiario == 2){
      var nuevo_porcentaje = 100 - this.fondeador.porcentaje_b1;
      if(this.fondeador.porcentaje_b2 < 0){
        alert("El porcentaje no puede ser un valor negativo");
        this.fondeador.porcentaje_b2 = nuevo_porcentaje;
      }else if(this.fondeador.porcentaje_b2 > 100){
        alert("El porcentaje no puede ser mayor a 100%");
        this.fondeador.porcentaje_b2 = nuevo_porcentaje;
      }else if(this.fondeador.porcentaje_b1 != 0) {
        if(this.fondeador.porcentaje_b2 > nuevo_porcentaje){
          alert("No puedes asignar un porcentaje mayor al permitido");
          this.fondeador.porcentaje_b2 = nuevo_porcentaje;
        }
      }
    }
  }
  //Registrar socio
  public registrarNuevoSocio(){
    //Registrar el formData
    this.armarFormData();
    
    //Llamamos al servicio
    this.socioFondeadorService.registrarSocioFondeador(this.formData)
      .subscribe(response => {
        const datosFondeador = response.json();

        console.log("Resp service socio-fondeador: ",datosFondeador);
        if (datosFondeador.success) {
          this.helperService.notification('Fondeador agregado', 'Se ha creado exitosamente el fondeador', 'success');
          setTimeout(() => {this.location.back()},3000);
          
        }
      }, error => {
        //this.processing = false;
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
          this.helperService.notification('ERROR', 'El tamaño del archivo no puede ser mayor a 2 MB.', 'error');
        }else{
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  public registrarSocio(){
    this.fondeadoresService.registrarSocioFondeador(this.fondeador)
      .subscribe(response => {
        const datosFondeador = response.json();

        console.log("Resp service socio: ",datosFondeador);

        this.processing = false;
        if (datosFondeador.success) {
          this.helperService.notification('Socio fondeador agregado', 'Se ha creado exitosamente el fondeador', 'success');
          //setTimeout(() => {window.location.reload()},3000);
          setTimeout(() => {
            this.router.navigate(["fondeadores"]);
          },2000);
          
        }
      }, error => {
        //this.processing = false;
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  //Actualizar
  public actualizar(){
    this.errors = [];
    //Funcion para validar campos del fondeador
    this.errors = this.fondeadoresService.validateUpdate(this.fondeador);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    console.log("Datos actualizar: ", this.fondeador);
    this.processing = true;

    this.actualizarFondeador();

  }
  
  //Validar cuando quiere generar la simulación
  public simulacionEsquema(){
    //Producto financiero
    if(this.producto_financiero.id === null){
      this.fondeador.idProductoFinanciero = "";
    }
    else
    {
      this.fondeador.idProductoFinanciero = this.producto_financiero.id;
    }

    //Capitalización
    if(this.opcCapitalizacion.length < 1){
      this.fondeador.capitalizacion = "";
    }
    else
    {
      this.fondeador.capitalizacion = this.opcCapitalizacion;
    }
    //Retención de impuestos
    if(this.opcRetencionImpuestos.length < 1){
      this.fondeador.retencion_impuestos = "";
    }
    else
    {
      this.fondeador.retencion_impuestos = this.opcRetencionImpuestos;
    }
    //Agregar null si no tiene tasa de retención
    if(this.fondeador.tasa_retencion === "" ){
      this.fondeador.tasa_retencion = null;
    }else if(this.fondeador.retencion_impuestos === "no"){
      this.fondeador.tasa_retencion = null;
    }

    if(this.fondeador.tipo_fondeador === "ahorrador"){
      this.fondeador.retencion_impuestos = "no";
      //Armar nuevo json
      this.inversion_ahorrador.fecha_inicio_inversion = this.fondeador.fecha_inicio_inversion;
      this.inversion_ahorrador.monto = this.fondeador.monto;
      this.inversion_ahorrador.tipo_fondeador = this.fondeador.tipo_fondeador;
      this.inversion_ahorrador.tasa_interes = this.producto_financiero.tasa;
      this.inversion_ahorrador.periodicidad = this.producto_financiero.periodicidad;
      this.inversion_ahorrador.plazo = this.producto_financiero.plazo;
      this.inversion_ahorrador.capitalizacion = parseInt(this.fondeador.capitalizacion);

      console.log("Esquema Ahorrador: ", this.inversion_ahorrador);
      
    }
    //Funcion para validar campos
    this.errors = this.fondeadoresService.validateEsquema(this.fondeador);
    
    if(!$.isEmptyObject(this.errors)){
      this.simulacion = false;
      return false;
    }
    this.esquema_inversion.monto = parseInt(this.fondeador.monto);
    this.simulacion = true;
    this.simulacionAhorrador = true;
    console.log("Datos simulación", this.esquema_inversion);
  }

  public close(){
    this.simulacion = false;
  }
  //Función para registrar fondeador
  public registrarFondeadores(){
    //console.log("Datos Ben: ",this.beneficiario);
    this.fondeadoresService.registrarFondeador(this.fondeador)
      .subscribe(response => {
        const datosFondeador = response.json();

        console.log("Resp service fondeador: ",datosFondeador);

        this.processing = false;
        if (datosFondeador.success) {
          this.helperService.notification('Fondeador agregado', 'Se ha creado exitosamente el fondeador', 'success');
          setTimeout(() => {window.location.reload()},3000);
          //location.reload();
          //window.location.reload();
          //this.goToCallback.emit('reload'); // when we emit, we reload the liquidation list 
        }
      }, error => {
        //this.processing = false;
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  //Actualizar fondeador
  public actualizarFondeador(){
    this.fondeadoresService.update(this.fondeador.id,this.fondeador)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          this.helperService.notification('Fondeador actualizado', 'Se ha actualizado exitosamente el fondeador: ' + this.fondeador.nombre, 'success');
          this.goToCallback.emit('reload'); 
          this.close();
        }
      }, error => {
        this.processing = false;

        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.close();
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }

        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
    });
  }

  public addPlazas(){
    this.plazasOpc = [{ id: 1, nombre: "CC"}, {id: 2, nombre: "AA"}, {id: 3, nombre: "AC"} ];
    
    if (this.plazasOpc.length>1){
      this.plazaPorDefecto = "Seleccione";
    } else if(this.plazasOpc.length>0){
      this.plazas =  this.plazasOpc[0];
    }
    
  }

  //Obtener beneficiarios
  private getBeneficiario(){
    this.beneficiariosService.getBeneficiarios().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult){
          this.beneficiariosOpc = jsonResult;
          console.log("Los beneficiarios: ", this.beneficiariosOpc);
          if (this.beneficiariosOpc.length>1){
            this.beneficiarioPorDefecto = "Seleccione";
          } else if(this.beneficiariosOpc.length>0){
            this.beneficiario_1 =  this.beneficiariosOpc[0];
            this.beneficiario_2 =  this.beneficiariosOpc[0];
          }
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Obtener productos financieros
  private getProductosFinancieros(page = null){
    this.productosService.getSelect().subscribe(
      (response)=>
      {
        const jsonResult = response.json().content;
        if(jsonResult){
          this.productosOpc = jsonResult;
          this.productosOpc.forEach((producto, index) => {
            var rangoMin = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(producto.rango_monto_min);
            var rangoMax = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(producto.rango_monto_max);
            var cadena = producto.nombre+" / "+rangoMin+" a "+rangoMax+" / "+"P. "+producto.plazo+" días";
            this.productosOpc[index].cadena = cadena;            
          });
          //this.productosOpc = jsonResult;
          console.log("Los productos: ", this.productosOpc);
          if (this.productosOpc.length>1){
            this.productoPorDefecto = "Seleccione";
          } else if(this.productosOpc.length>0){
            this.producto_financiero =  this.productosOpc[0];
          }
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  //Obtener productos financieros por tipo de fondeador
  private getProductosFinancierosTipo(){
    this.productosService.getSelectTipo(this.tipo_fondeador).subscribe(
      (response)=>
      {
        const jsonResult = response.json().content;
        if(jsonResult){
          this.productosOpc = jsonResult;
          this.productosOpc.forEach((producto, index) => {
            var rangoMin = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(producto.rango_monto_min);
            var rangoMax = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(producto.rango_monto_max);
            var cadena = producto.nombre+" / "+rangoMin+" a "+rangoMax+" / "+"P. "+producto.plazo+" días";
            this.productosOpc[index].cadena = cadena;            
          });
          //this.productosOpc = jsonResult;
          console.log("Los productos: ", this.productosOpc);
          if (this.productosOpc.length>1){
            this.productoPorDefecto = "Seleccione";
          } else if(this.productosOpc.length>0){
            this.producto_financiero =  this.productosOpc[0];
          }
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  sucursalChanged(sucursal){
    console.log("Event Sucursal: ", sucursal);
    
    if(sucursal){
        this.sucursalSelected = sucursal;
        console.log("Sucursal: ",this.sucursalSelected.id);
        // this.getGastosPorMes();
    }
  }
  
  promotorChanged(promotor){
    console.log("Event Promotor: ", promotor);
    
    if(promotor){
        this.promotorSelected = promotor;
        this.fondeador.idPromotor = this.promotorSelected.id;
        console.log("Promotor: ",this.promotorSelected.id);
        // this.getGastosPorMes();
    }
  }

  //Saber la empresa seleccionada
  public empresasChanged(empresaSelect){
    if(empresaSelect){
      this.empresa = empresaSelect;
      console.log("Empresa seleccionada: ", this.empresa);
      
    }
  }

  //Función para saber que beneficiario ha sido seleccionado
  public beneficiarioUnoChanged(beneficiarioUno){
    if(beneficiarioUno){
      this.beneficiario_1 = beneficiarioUno;
      console.log("Beneficiario_1: ",this.beneficiario_1);
    }
  }
  public beneficiarioDosChanged(beneficiarioDos){
    if(beneficiarioDos){
      this.beneficiario_2 = beneficiarioDos;
      console.log("Beneficiario_2: ",this.beneficiario_2);
    }
  }
  //Saber que esquema de inversión ha sido seleccionado
  public productoFinancieroChanged(producto){
    if(producto.nombre){
      this.producto_financiero = producto;
      //Validar rangos
      this.fondeador.monto = this.producto_financiero.rango_monto_min;
      //Agregamos el monto, la tasa y el plazo
      this.esquema_inversion.tasa = this.producto_financiero.tasa;
      this.esquema_inversion.plazo = this.producto_financiero.plazo;
      //Cuando cambia el select asigna la fecha final de inversión
      if(this.fondeador.fecha_inicio_inversion === "" ){
        this.fondeador.fecha_fin_inversion = "";
      }else{
        this.fechaTemp = new Date(this.fondeador.fecha_inicio_inversion.replace(/-/g, '\/'));
        console.log("FechaInit: ", this.fechaTemp);
        this.fechaTemp.setDate(this.fechaTemp.getDate()+this.producto_financiero.plazo);
        this.fechaTemp = this.fechaTemp.toISOString();
        //Separamos la fecha
        var f = this.fechaTemp.split("T")[0];
        this.fondeador.fecha_fin_inversion = f;
        console.log("Fond_fecha: ", this.fondeador.fecha_fin_inversion);
      }
    }else{
      this.fondeador.fecha_fin_inversion = "";
    }
  }

  public actualizarEsquema(){
    if(this.producto_financiero.nombre != ""){
      console.log("Monto: ", this.fondeador.monto);
      //Validar rango
      if(Number(this.fondeador.monto) > this.producto_financiero.rango_monto_max){
        alert("Ha excedido el monto del esquema de inversión");
        this.fondeador.monto = this.producto_financiero.rango_monto_max;
      }
      if(Number(this.fondeador.monto) < this.producto_financiero.rango_monto_min){
        alert("La cantidad no corresponde al mínimo de inversión");
        this.fondeador.monto = this.producto_financiero.rango_monto_min;
      }
      //Esto lo hace solo si es un socio
      if(this.bandSocio){
        if(Number(this.fondeador.monto) > this.socio_fondeador.saldo){
          alert("No cuenta con saldo suficiente para invertir esa cantidad");
          this.fondeador.monto = this.socio_fondeador.saldo;
        }
      }
      //Validar fechas
      if(this.fondeador.fecha_inicio_inversion === "" || this.fondeador.monto === ""){
        this.fondeador.fecha_fin_inversion = "";
      }else{
        this.fechaTemp = new Date(this.fondeador.fecha_inicio_inversion.replace(/-/g, '\/'));
        console.log("FechaInit: ", this.fechaTemp);
        this.fechaTemp.setDate(this.fechaTemp.getDate()+this.producto_financiero.plazo);
        this.fechaTemp = this.fechaTemp.toISOString();
        //Separamos la fecha
        var f = this.fechaTemp.split("T")[0];
        this.fondeador.fecha_fin_inversion = f;
      }
    }else{
      this.fondeador.fecha_fin_inversion = "";
    }
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }

  public plazasChanged(plaza){
    if(plaza){
      this.plazas = plaza;
      console.log("Plaza : ",this.plazas);
    }
  }

  public getTipoEntidad(){
    
    if(this.opcTipoEntidad === "fisica")
      this.isPersonaFisica = true;
    else
      this.isPersonaFisica = false;
  }

  public getTipoFondo(){
    console.log("Tipo Fondo: ",this.opcTipoFondo);
    if(this.opcTipoFondo == "tarjeta"){
      this.esTarjeta = true;
      this.esCLABE = false;
    }else if(this.opcTipoFondo == "clabe"){
      this.esCLABE = true;
      this.esTarjeta = false;
    }else{
      this.esTarjeta = false;
      this.esCLABE = false;
    }
  }
  public getDepositoFondo(){
    if(this.opcDepositoFondo === "transferencia")
      this.isBanco = true;
    else
      this.isBanco = false;
  }

  public getCapitalizacion(){
    console.log("Capitalizacion: ", this.opcCapitalizacion);
    
  }
  public getRetencionImpuestos(){
    if(this.opcRetencionImpuestos === "si")
      this.isRetencionImpuestos = true;
    else
      this.isRetencionImpuestos = false;

    console.log("Retencion_impuestos: ", this.opcRetencionImpuestos);
    
  }
  public nuevoBeneficiario(evento: string){
    if(evento == "agregar"){
      this.isNuevoBeneficiario = true;
      if(this.fondeador.porcentaje_b1 != 0) {
        var nuevo_porcentaje = 100 - this.fondeador.porcentaje_b1;
        this.fondeador.porcentaje_b2 = nuevo_porcentaje;
      }
    }
    else if(evento == "cancelar"){
      this.fondeador.porcentaje_b2 = 0;
      this.isNuevoBeneficiario = false;
      this.fondeador.porcentaje_b1 = 100;
    }
  }

  public limpiarEsquema(){
    this.fondeador.monto = "";
    this.fondeador.fecha_inicio_inversion ="";
    this.fondeador.fecha_fin_inversion ="";
  }

  public radioChange($event: MatRadioChange) {
    console.log($event.source.name, $event.value);

    if ($event.value === 'ahorrador') {
      this.esAhorrador = true;
      this.tipo_fondeador = "Ahorrador";
      //this.limpiarEsquema();
      this.esInversionista = false;
      this.tipoInversionista = false;
      this.simulacion = false;
      this.simulacionAhorrador = false;
      //this.getProductosFinancierosTipo();
    }else if($event.value === 'inversionista'){
      this.simulacionAhorrador = false;
      this.simulacion = false;
      //this.limpiarEsquema();
      this.esAhorrador = false;
      this.tipoInversionista = true;
      this.tipo_fondeador = "Inversionista";
      this.esInversionista = true;
      //this.getProductosFinancierosTipo();
    }
  }

  //Files
  public uploadFile(event : any, tipo: string) {
    // console.log("File: ", event, "Tipo: ", tipo);
    console.log("Cargar");
    
    switch(tipo){
      case 'ine':
        this.fileList_INE = event.target.files;
        console.log("INE: ", this.fileList_INE, "Tipo: ", tipo);
        if(this.fileList_INE.length > 0) {
          let file_1: File = this.fileList_INE[0];
          this.archivo_ine = file_1.name;
          this.fondeador.archivo_ine = this.fileList_INE;
        }
        break;
      case 'comprobante':
        this.fileList_Comprobante = event.target.files;
        console.log("Dom: ", this.fileList_Comprobante, "Tipo: ", tipo);
        if(this.fileList_Comprobante.length > 0) {
          let file_2: File = this.fileList_Comprobante[0];
          this.archivo_dom = file_2.name;
          this.fondeador.archivo_domicilio = this.fileList_Comprobante;
        }
        break;
      case 'rfc':
        this.fileList_RFC = event.target.files;
        console.log("RFC: ", this.fileList_RFC, "Tipo: ", tipo);
        if(this.fileList_RFC.length > 0) {
          let file_3: File = this.fileList_RFC[0];
          this.archivo_rfc = file_3.name;
          this.fondeador.archivo_rfc = this.fileList_RFC;
        }
        break;
      default :
        console.log("Selecciona algún archivo");
        
    }
    
  }

  public deleteFile(tipo: string){
    switch(tipo){
      case 'ine':
        this.fileList_INE = null;
        console.log("INE: ", this.fileList_INE, "Tipo: ", tipo);
        this.archivo_ine = "";
        this.fondeador.archivo_ine = "";
        break;
      case 'comprobante':
        this.fileList_Comprobante = null;
        console.log("Dom: ", this.fileList_Comprobante, "Tipo: ", tipo);
        this.archivo_dom = "";
        this.fondeador.archivo_domicilio = "";
        break;
      case 'rfc':
        this.fileList_RFC = null;
        console.log("RFC: ", this.fileList_RFC, "Tipo: ", tipo);
        this.archivo_rfc = "";
        this.fondeador.archivo_rfc = "";
        break;
      default :
        console.log("Borrar archivo");
        
    }
  }
  
}

//Alternativa
  // public formData(){
  //   //Armamos el formData
  //   for (let key in this.fondeador) {
  //     //console.log("Llave: ",key, "Dato: ", this.fondeador[key]);
  //     if(key != "archivo_ine"){
  //       if(key != "archivo_domicilio"){
  //         if(key != "archivo_rfc"){
  //           if(this.fondeador[key] != null){
  //             this.formData.append(key, this.fondeador[key]);
  //           }else{
  //             this.formData.append(key,null);
  //           }
  //         }
  //       }
  //     }
  //   }
  // }


// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/registro-fondeador/registro-fondeador.component.ts